module.exports = __webpack_public_path__ + "img/producer.ae2049e2.svg";